import React, { useState } from 'react';
import './Options.css';
import Optionsicon from './Optionsicon';

function Options() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  return (
    <>
      <Optionsicon toggleMenu={toggleMenu} />

      <div className={`side-menu ${isOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleMenu}>×</button>
        <div className='options'>
            <ul>
                <li><a href="/">HOME</a></li>
                <li><a href="/projects">PROJECTS</a></li>
                <li><a href="/resume">RESUME</a></li>
                <li><a href="/journal">JOURNAL</a></li>
                <li><a href="/shop">SHOP</a></li>
            </ul>
        </div>
      </div>
    </>
  );
}

export default Options;
